<template>
  <a-row justify="center">
    <a-col :lg="6">
      <AuthWrapper>
        <div class="ninjadash-authentication-top">
          <h2 class="ninjadash-authentication-top__title">Sign Up NinjaDash</h2>
        </div>
        <div class="ninjadash-authentication-content">
          <a-form
            name="register"
            :model="formState"
            @finish="handleSubmit"
            layout="vertical"
          >
            <a-form-item
              label="Name"
              name="name"
              :rules="[
                { required: true, message: 'Please input your Full name!' },
              ]"
            >
              <a-input v-model:value="formState.name" placeholder="Full name" />
            </a-form-item>
            <a-form-item
              name="username"
              label="Username"
              :rules="[
                { required: true, message: 'Please input your username!' },
              ]"
            >
              <a-input
                v-model:value="formState.username"
                placeholder="Username"
              />
            </a-form-item>
            <a-form-item
              name="email"
              label="Email Address"
              :rules="[
                {
                  required: true,
                  message: 'Please input your email!',
                  type: 'email',
                },
              ]"
            >
              <a-input
                type="email"
                v-model:value="formState.email"
                placeholder="name@example.com"
              />
            </a-form-item>
            <a-form-item
              label="Password"
              name="password"
              :rules="[
                { required: true, message: 'Please input your password!' },
              ]"
            >
              <a-input
                type="password"
                v-model:value="formState.password"
                placeholder="Password"
              />
            </a-form-item>
            <div class="ninjadash-auth-extra-links">
              <a-checkbox @change="onChange">
                Creating an account means you’re okay with our Terms of Service
                and Privacy Policy
              </a-checkbox>
            </div>
            <a-form-item>
              <sdButton
                class="btn-create"
                htmlType="submit"
                type="primary"
                size="lg"
                :disabled="isLoading"
              >
                {{ isLoading ? "Loading..." : "Create Account" }}
              </sdButton>
            </a-form-item>
            <p class="ninjadash-form-divider">
              <span>Or</span>
            </p>
            <ul class="ninjadash-social-login">
              <li>
                <a
                  @click="() => dispatch('firebaseAuthLoginWithGoogle')"
                  class="google-social"
                  href="#"
                >
                  <InlineSvg
                    :src="require('@/static/img/icon/google-plus.svg')"
                  ></InlineSvg>
                </a>
              </li>
              <li>
                <a
                  @click="() => dispatch('firebaseAuthLoginWithFacebook')"
                  class="facebook-social"
                  href="#"
                >
                  <unicon name="facebook-f"></unicon>
                </a>
              </li>
              <li>
                <a class="twitter-social" href="#">
                  <unicon name="twitter"></unicon>
                </a>
              </li>
              <li>
                <a class="twitter-social" href="#">
                  <unicon name="github"></unicon>
                </a>
              </li>
            </ul>
          </a-form>
        </div>
        <div class="ninjadash-authentication-bottom">
          <p>
            Already have an account?<router-link to="/auth/login"
              >Sign In</router-link
            >
          </p>
        </div>
      </AuthWrapper>
    </a-col>
  </a-row>
</template>
<script>
import { AuthWrapper } from "./style";
import { computed, reactive, ref } from "vue";
import { useStore } from "vuex";
import InlineSvg from "vue-inline-svg";

const SignUp = {
  name: "SignUp",
  components: { AuthWrapper, InlineSvg },
  setup() {
    const values = ref(null);
    const checked = ref(null);
    const isLoading = computed(() => state.firebase.loading);
    const { state, dispatch } = useStore();

    // const handleFbLogin = () => {
    //   router.push("/");
    //   dispatch("login");
    // };

    // watchEffect(() => {
    //   if (uid.value) {
    //     handleFbLogin();
    //   }
    // });

    const handleSubmit = (value) => {
      values.value = value;
      dispatch("firebaseAuthSignUp", { ...values.value, terms: checked.value });
    };

    const onChange = (e) => {
      checked.value = e.target.checked;
    };
    const formState = reactive({
      name: "",
      username: "",
      email: "",
      password: "",
    });
    return {
      onChange,
      handleSubmit,
      formState,
      checked,
      isLoading,
    };
  },
};

export default SignUp;
</script>
